import React from 'react';
import _ from "underscore";

import RetinaImage from "react-retina-image"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

import config from "../../config";
import DesignerMenuItem from "./common/DesignerMenuItem";

const DesignersMenu = ({ designers, menu_item, show_designers_menu }) => {
    if(_.isEmpty(designers)){
        return null;
    }

    const designers_all = _.filter(designers, (designer) => {return designer.show_in_menu === true}).slice(0, 29);
    const designers_popular = _.filter(designers, (designer) => {return designer.is_popular === true});

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 3, offset: 0 }} >
                        <h4 className="top-nav__nav-title">{menu_item && menu_item.collections_info && menu_item.collections_info.title}</h4>
                        <Nav className="top-nav__nav-list">
                            {designers_popular && designers_popular.length > 0 && _.map(designers_popular, (designer) => {
                                return (
                                    <DesignerMenuItem
                                        key={designer.id}
                                        url={menu_item.href}
                                        menu_item={menu_item}
                                        designer={designer}
                                        show_designers_menu={show_designers_menu}
                                        classname="top-nav__nav-list-item-primary"
                                    />
                                )
                            })}
                        </Nav>
                    </Col>
                    <Col lg={4}>
                        <h4 className="top-nav__nav-title">Designers</h4>
                        <Row>
                            <Col lg={6}>
                                <Nav className="top-nav__nav-list">
                                    {_.map(designers_all.slice(0, 10), (designer) => {
                                        return (
                                            <DesignerMenuItem
                                                key={designer.id}
                                                url={menu_item.href}
                                                menu_item={menu_item}
                                                designer={designer}
                                                show_designers_menu={show_designers_menu}
                                                classname="top-nav__nav-list-item-secondary"
                                            />
                                        )
                                    })}
                                </Nav>
                            </Col>
                            <Col lg={6}>
                                <Nav className="top-nav__nav-list">
                                    {_.map(designers_all.slice(10, 19), (designer) => {
                                        return (
                                            <DesignerMenuItem
                                                key={designer.id}
                                                url={menu_item.href}
                                                menu_item={menu_item}
                                                designer={designer}
                                                show_designers_menu={show_designers_menu}
                                                classname="top-nav__nav-list-item-secondary"
                                            />
                                        )
                                    })}
                                    <Nav.Item
                                        className="top-nav__nav-list-item-secondary nav-top-link"
                                        as="a"
                                        href={menu_item.href}
                                    >
                                        <span
                                            className="inner-focus"
                                            tabIndex="-1"
                                        >
                                            All Designers
                                        </span>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={4} lg={5}>
                        <a href={`${config.host_rebag}/refer/`}>
                            <RetinaImage
                                alt={"Refer a friend"}
                                title={"Refer a friend"}
                                className="top-nav__promo-image"
                                src={`${config.MEDIA_URL}/promos/designers-nav-02.28.2023.jpg`}
                            />
                        </a>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DesignersMenu;